import React from 'react';
import { Footer } from '../components/HomePage';
//import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import MyProfile from '../components/MyProfile/MyProfile';

function MyProfilePage() {
  return (
    <>
      <MyProfile />
      <Footer />
    </>
  );
}

export default MyProfilePage;